export enum EkranDecyzjaRoszczeniaActionType {
  KLIKNIETO_DALEJ_ROSZCZENIE = '[Ekran Decyzja Roszczenia] Kliknieto dalej',
  KLIKNIETO_DALEJ_ROSZCZENIE_SUCCESS = '[Ekran Decyzja Roszczenia] Kliknieto dalej sukces',
  KLIKNIETO_WROC = '[Ekran Decyzja Roszczenia] Kliknieto wroc',
  KLIKNIETO_WROC_SUCCESS = '[Ekran Decyzja Roszczenia] Kliknieto wroc sukces'
}
